import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { LazyLoadScriptService } from './../sidebar/lazy-load-script.service'
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-account',
    templateUrl: './account.component.html',
    styleUrls: ['./account.component.css']
})

export class AccountComponent implements OnInit {
    imageoneAccount: boolean = false;
    pageTitle: string;
    pageDisplay: string;

    constructor(
        private activatedroute: ActivatedRoute,
        private router: Router,
        private lazyLoadService: LazyLoadScriptService
    ) { }

    ngOnInit(): void {
        var applicationName = "accountappelement";

        this.lazyLoadService.loadScript(environment["ACCOUNTAPPURL"], applicationName).subscribe(_ => {
            let url = this.router.url;
            if (url == '/account/creditmemo') {
                this.pageTitle = "Credit Memo List";
                this.pageDisplay = "creditMemoList";
            } else if (url == '/account/appliedcreditmemo') {
                this.pageTitle = "Applied Credit Memo List";
                this.pageDisplay = "appliedCreditMemoList";
            } else if (url == '/account/voidcreditmemo') {
                this.pageTitle = "Void Credit Memo List";
                this.pageDisplay = "voidCreditMemoList";
            } else if (url == '/account/createinvoice') {
                this.pageTitle = "Create Invoice";
                this.pageDisplay = "createInvoice";
            } else if (url == '/account/invoice') {
                this.pageTitle = "Invoices";
                this.pageDisplay = "invoices";
            } else if (url == '/account/voidinvoice') {
                this.pageTitle = "Voided Invoice List";
                this.pageDisplay = "voidedInvoiceList";
            } else if (url == '/account/exportinvoice') {
                this.pageTitle = "Export Invoices";
                this.pageDisplay = "exportInvoices";
            } else if (url.includes('/account/editinvoice')) {
                this.pageTitle = "Update Invoice";
                this.pageDisplay = "UpdateInvoice";
            } else if (url == '/account/createcreditmemo') {
                this.pageTitle = "Create Credit Memo";
                this.pageDisplay = "CreateCreditMemo";
            } else if (url.includes('/account/creditmemodetails')) {
                this.pageTitle = "Credit Memo Details";
                this.pageDisplay = "CreditMemoDetails";
            } else if (url.includes('/account/printcreditmemo')) {
                this.pageTitle = "Credit Memo Details";
                this.pageDisplay = "PrintCreditMemo";
            } else if (url == '/account/recurringinvoice') {
                this.pageTitle = "Recurring Invoice";
                this.pageDisplay = "RecurringInvoice";
            } else if (url.includes('/account/editrecurringinvoice')) {
                this.pageTitle = "Recurring Invoice";
                this.pageDisplay = "UpdateRecurringInvoice";
            } else if (url == '/account/printrecurringinvoice') {
                this.pageTitle = "Recurring Invoice Statement";
                this.pageDisplay = "RecurringInvoiceStatement";
            } else if (url == '/account/printinvoices') {
                this.pageTitle = "Invoice Statement";
                this.pageDisplay = "InvoiceStatement";
            } else if (url == '/account/receivedpayments') {
                this.pageTitle = "Received Payments";
                this.pageDisplay = "ReceivedPayments";
            } else if (url == '/account/voidpayments') {
                this.pageTitle = "Void Payments";
                this.pageDisplay = "VoidPayments";
            } else if (url == '/account/newpayment') {
                this.pageTitle = "New Payment";
                this.pageDisplay = "NewPayment";
            } else if (url.includes('/account/editreceivedpayment')) {
                this.pageTitle = "Update Payment";
                this.pageDisplay = "UpdatePayment";
            } else if (url.includes('/account/invoicepayment')) {
                this.pageTitle = "Payment Details";
                this.pageDisplay = "PaymentDetails";
            } else if (url == '/account/clientstatements') {
                this.pageTitle = "Client Statements";
                this.pageDisplay = "ClientStatements";
            } else if (url.includes('/account/viewclientstatement')) {
                this.pageTitle = "Client Statement";
                this.pageDisplay = "ClientStatementDetail";
            } else if (url == '/account/createclientstatement') {
                this.pageTitle = "Create Client Statement";
                this.pageDisplay = "CreateClientStatement";
            } else if (url == '/account/franchiseestatements') {
                this.pageTitle = "Franchisee Statements";
                this.pageDisplay = "FranchiseeStatements";
            } else if (url == '/account/archivedstatements') {
                this.pageTitle = "Archived Statement List";
                this.pageDisplay = "ArchivedStatementList";
            } else if (url.includes('/account/viewfranchiseestatement')) {
                this.pageTitle = "Franchisee Statement";
                this.pageDisplay = "FranchiseeStatementDetail";
            } else if (url == '/account/createfranchiseestatement') {
                this.pageTitle = "Create Franchise Statement";
                this.pageDisplay = "CreateFranchiseeStatement";
            } else if (url == '/account/printfranchiseestatements') {
                this.pageTitle = "Franchisee Statement";
                this.pageDisplay = "FranchiseeStatement";
            } else if (url == '/account/franchiseeItems') {
                this.pageTitle = "Administration Charges";
                this.pageDisplay = "franchiseeItems";
            } else if (url == '/account/supplyitems') {
                this.pageTitle = "Supplies";
                this.pageDisplay = "supplies";
            } else if (url == '/account/notepayments') {
                this.pageTitle = "Note Payments";
                this.pageDisplay = "notepayments";
            } else if (url.includes('/account/franchiseepayment')) {
                this.pageTitle = "Franchisee Payment";
                this.pageDisplay = "FranchiseePayment";
            } else if (url == '/account/transfers') {
                this.pageTitle = "Transfers";
                this.pageDisplay = "Transfers";
            } else if (url == '/account/startups') {
                this.pageTitle = "Start-Ups";
                this.pageDisplay = "Startups";
            } else if (url == '/account/cancellations') {
                this.pageTitle = "Cancellations";
                this.pageDisplay = "Cancellations";
            } else if (url == '/account/addendum') {
                this.pageTitle = "Addendum List";
                this.pageDisplay = "AddendumList";
            } else if (url == '/account/addtransfer') {
                this.pageTitle = "Start Up / Transfer";
                this.pageDisplay = "AddStartUpTransfer";
            } else if (url.includes('/account/edittransfer')) {
                this.pageTitle = "Update Transfer Information";
                this.pageDisplay = "UpdateStartUpTransfer";
            } else if (url.includes('/account/editstartup')) {
                this.pageTitle = "Update Startup Information";
                this.pageDisplay = "UpdateStartUpTransfer";
            } else if (url == '/account/addcancellation') {
                this.pageTitle = "New Cancellation";
                this.pageDisplay = "NewCancellation";
            }  else if (url == '/account/addadministrationcharge') {
                this.pageTitle = "New Administrative Charge";         
                this.pageDisplay = "addamincharge";
            } else if (url.includes('/account/editadmincharge')) {
                this.pageTitle = "Update Administrative Charge";
                this.pageDisplay = "editadminstrationcharge";
            } else if (url.includes('/account/editcancellations')) {
                this.pageTitle = "Update Cancellation";
                this.pageDisplay = "UpdateCancellation";
            } else if (url == '/account/newsupplyitem') {
                this.pageTitle = "New Supply";         
                this.pageDisplay = "newSupply";
            } else if (url.includes('/account/editsupplyitem')) {
                this.pageTitle = "Update Supply";         
                this.pageDisplay = "updateSupply";
            } else if (url == '/account/newaddendum') {
                this.pageTitle = "Addendum";
                this.pageDisplay = "AddAddendum";
            } else if (url.includes('/account/editaddendum')) {
                this.pageTitle = "Update Addendum";
                this.pageDisplay = "UpdateAddendum";
            } else if (url == '/account/salescommissionstatements') {
                this.pageTitle = "Commission Tracking Sheets";
                this.pageDisplay = "CommissionTrackingSheets";
            } else if (url == '/account/completednotepayment') {
                this.pageTitle = "Note Payments";
                this.pageDisplay = "completedNotePayments";
            } else if (url == '/account/salescommissionstatementsmine') {
                this.pageTitle = "Commission Tracking Sheets";
                this.pageDisplay = "CommissionTrackingSheetsMine";
            } else if (url == '/account/printcommissionstatements') {
                this.pageTitle = "Commision Statement";
                this.pageDisplay = "PrintCommisionStatement";
            } else if (url == '/account/newnotepayment') {
                this.pageTitle = "New Note Payment";
                this.pageDisplay = "newNotePayment";
            } else if (url.includes('/account/editnotepayment')) {
                this.pageTitle = "Update Note Payment";
                this.pageDisplay = "editNotePayment";
            } else if (url == '/account/createcommissionstatement') {
                this.pageTitle = "Create Commission Tracking Sheet";
                this.pageDisplay = "CreateCommissionTrackingSheet";
            } else if (url.includes('/account/viewcommissionstatement')) {
                this.pageTitle = "Commission Tracking Sheet";
                this.pageDisplay = "ViewCommissionTrackingSheet";
            } else if (url == '/account/reimbursement') {
                this.pageTitle = "Reimbursements";
                this.pageDisplay = "Reimbursements";
            } else if (url == '/account/bonuses') {
                this.pageTitle = "Bonuses";
                this.pageDisplay = "Bonuses";
            } else if (url == '/account/addbonus') {
                this.pageTitle = "Add Bonus";
                this.pageDisplay = "AddBonus";
            } else if (url == '/account/managebonus') {
                this.pageTitle = "Manage Bonuses";
                this.pageDisplay = "ManageBonus";
            }  else if (url == '/account/addreimbursement') {
                this.pageTitle = "Add Reimbursement";
                this.pageDisplay = "Addreimbursement";
            } else if (url.includes('/account/editreimbursement')) {
                this.pageTitle = "Edit Reimbursement";
                this.pageDisplay = "Editreimbursement";
            } else if (url.includes('/account/editbonus')) {
                this.pageTitle = "Update Bonus";
                this.pageDisplay = "UpdateBonus";
            } else if (url == '/account/collections') {
                this.pageTitle = "Collections";
                this.pageDisplay = "Collections";
            } else if (url == '/account/collectionstatement') {
                this.pageTitle = "Collection Statement";
                this.pageDisplay = "PrintCollectionStatement";
            } else if (url == '/account/workorders') {
                this.pageTitle = "Work Orders";
                this.pageDisplay = "workOrders";
            }else if (url == '/account/newinsurance') {
                this.pageTitle = "New Insurance";
                this.pageDisplay = "newInsurance";
            } else if (url.includes('/account/editinsurance')) {
                this.pageTitle = "Edit Insurance";
                this.pageDisplay = "editInsurance";
            } else if (url == '/account/insurance') {
                this.pageTitle = "Insurance";
                this.pageDisplay = "Insurance";
            } else if (url == '/account/exportcollections') {
                this.pageTitle = "Export Collections";
                this.pageDisplay = "ExportCollections";
            } else if (url == '/account/import') {
                this.pageTitle = "Import Counties";
                this.pageDisplay = "importCounties";
            } else if (url == '/account/collectionhistory') {
                this.pageTitle = "Collection Mail History";
                this.pageDisplay = "CollectionMailHistory";
            } else if (url.includes('/account/collectionstatementdetail')) {
                this.pageTitle = "Collection";
                this.pageDisplay = "CollectionStatementDetail";
            }
            
            this.imageoneAccount = true;
        });       
    }

    ngOnDestroy(): void {
        this.imageoneAccount = false;
    }
}